// React Dependencies
import React from 'react';

// External Dependencies
import _ from 'lodash';
import PropTypes from 'prop-types';

// Internal Dependencies
import MapModel from './MapModel';
import Waypoint from './Waypoint';
import Edge from './Edge';
import { useMallMapStore } from '../../../hook/useMallMapStore';
import { MallMapManageButtons } from '../../../common/constants';

const MapModelAllLevel = ({
  posX,
  posY,
  index,
  mallMap,
  mallMapEdges,
  mallMapLabels,
  setCurrentLevel,
  onClickWaypoint,
  onAddWaypoint,
  setIsMapControlEnabled,
}) => {
  const position = [posX, 0, posY];
  const { selectedButton, waypointType, selectedWaypoint } = useMallMapStore((state) => state);

  const getLogo = (waypoint) => {
    if (waypoint.outlet_id) return waypoint.page_logo;
    else if (waypoint.mall_directory_id) return waypoint.brand_logo;
    else return null;
  };

  const clickWaypointHandler = (e, waypoint) => {
    onClickWaypoint(e, waypoint, posY);
  };

  const addNewWaypointHandler = (event) => {
    if (selectedButton !== MallMapManageButtons.MANAGE_WAYPOINTS) return;

    const { x, z } = event.point;
    const payload = {
      mallMapId: mallMap.id,
      pageId:    mallMap.pageId,
      outletId:  null,
      x,
      y:         (z * -1) + posY,
      lat:       0,
      lng:       0,
      type:      waypointType.value,
    };

    onAddWaypoint(payload, posY);
  };

  const pointerOnMapHandler = _.debounce(() => {
    setCurrentLevel(mallMap.level);
  }, 500);

  return (
    <>
      <group onPointerEnter={pointerOnMapHandler} onContextMenu={addNewWaypointHandler}>
        <MapModel model={mallMap.model} position={position} />
      </group>

      <mesh position={[0, 2.5, 0.1]} rotation={[-1.5, 0, 0]}>
        {
        _.map(mallMapEdges, (arrowEdge) => (
          <Edge
            key={`edge-${arrowEdge.id}`}
            geometry={arrowEdge.geometry}
            isHighlight={arrowEdge.isHighlight}
          />
        ))
        }

        {
          _.map(mallMapLabels, (label) => (
            <primitive key={label.key} object={label.object} />
          ))
        }

        {
        _.map(mallMap.waypoints, (waypoint) => (
          <Waypoint
            key={`waypoint-${waypoint.id}`}
            mapIndex={index}
            id={waypoint.id}
            type={waypoint.type}
            logo={getLogo(waypoint)}
            selectedId={selectedWaypoint ? selectedWaypoint.id : null}
            position={[waypoint.x, waypoint.y, index === 0 ? 0.6 : 0.6 + ((index + 1) ** 2) - index]}
            enableMove={false}
            onClick={(e) => clickWaypointHandler(e, waypoint)}
            onDrag={() => {}}
            setIsMapControlEnabled={setIsMapControlEnabled}
          />
        ))
        }
      </mesh>
    </>
  );
};

MapModelAllLevel.propTypes = {
  posY:                   PropTypes.number,
  posX:                   PropTypes.number,
  onClickWaypoint:        PropTypes.func.isRequired,
  onAddWaypoint:          PropTypes.func.isRequired,
  index:                  PropTypes.number,
  mallMap:                PropTypes.shape(Object),
  mallMapEdges:           PropTypes.arrayOf(PropTypes.shape(Object)),
  mallMapLabels:          PropTypes.arrayOf(PropTypes.shape(Object)),
  setCurrentLevel:        PropTypes.func.isRequired,
  setIsMapControlEnabled: PropTypes.func.isRequired,
};

MapModelAllLevel.defaultProps = {
  posY:          0,
  posX:          0,
  index:         0,
  mallMap:       {},
  mallMapEdges:  [],
  mallMapLabels: [],
};

export default MapModelAllLevel;
